import { biggerPhone, phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

const gapForBlocks = 20

export const StyledHeading1 = styled.h1`
  font-size: 48px;
  font-weight: 900;
  letter-spacing: -0.48px;
  line-height: 120%; /* 57.6px */
  text-align: center;

  ${biggerPhone(css`
    font-size: 36px;
  `)}
`

export const StyledHeading2 = styled.h2`
  padding: 0 53px;
  font-size: 24px;
  font-weight: 700;
  line-height: 120%; /* 28.8px */

  ${phone(css`
    padding: 0;
  `)}
`

export const StyledHeading3 = styled.h3`
  padding: 0 53px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */

  ${phone(css`
    padding: 0;
  `)}
`

export const StyledHeading4 = styled.h4`
  padding: 0 53px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 21.6px */

  ${phone(css`
    padding: 0;
  `)}
`

export const StyledParagraph = styled.p`
  padding: 0 53px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  > strong {
    font-weight: 700;
  }

  ${phone(css`
    padding: 0;
  `)}
`

export const StyledFirstParagraph = styled(StyledParagraph)`
  font-size: 18px;
  line-height: 28px;
`

export const StyleUnorderedList = styled.ul`
  padding: 0 53px;
  margin-top: -${gapForBlocks}px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  list-style: inside;

  ${phone(css`
    padding: 0 0 0 26px;
    padding-inline-start: 24px;
  `)};
  ul {
    padding: 0 26px;
    margin-top: 0;

    ${phone(css`
      padding: 0 0 0 26px;
      margin-block: 0;
    `)}
  }
`

export const StyleListItem = styled.li`
  padding: 0 24px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  list-style: inside;

  ${phone(css`
    padding: 0 12px;
  `)}
`

export const StyledLink = styled.a`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  overflow-wrap: anywhere;
  text-decoration-line: underline;
  text-decoration-skip-ink: none;
  text-decoration-style: solid;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;

  &:has(> sup) {
    text-decoration-line: none;
  }
`

export const StyledContentWrapper = styled.article`
  display: flex;
  max-width: 848px;
  flex-direction: column;
  padding: 80px 24px 258px;
  margin: 0 auto;
  gap: ${gapForBlocks}px;

  ${phone(css`
    padding: 40px 24px 78px;
  `)}
`

export const StyledFooter = styled.footer`
  padding: 0 53px;

  ${phone(css`
    padding: 0;
  `)}
`

export const StyledSup = styled.sup`
  font-size: smaller;
  vertical-align: super;
`

export const StyledStrong = styled.strong`
  font-weight: bolder;
`
